<template>
    <div>
        <div class="h1">

            <div class="s6">
                <div class="w">

                    <count-down class="daojishi" :endTime="endTime" :endText="endText" />
                </div>
            </div>

        </div>
    </div>
</template>

<script>

import countDown from '@/components/countDown'//引入路径，可更改
export default {
    data() {
        return {
            endTime: new Date("2023/02/17 18:00:00").getTime() / 1000 + ' ',
            //  console.log(endTime)=>得到毫秒  1658030420 可在方法里面放入后台数据,new Date('放后台数据').getTime() / 1000 +  ' ',但要记得调用方法
            endText: '活动结束',
            xAxis: [],
            yAxis: [],
            people: "36",
            newtime: "",
            month: "",
            // 剩余端口
            surplus: ""
        };
    }, components: {
        countDown
    },
    mounted() {
        // echarts
        this.getEchartData()
        console.log("new Date().getTime():", new Date().getTime())
        this.newtime = new Date().getTime();
        this.timess()
    },
    methods: {


    }
};
</script>
<style lang="less" scoped>
* {
    font-size: 16px;
}



.h1 {
    margin: 0 auto;
    width: 1644px;
    height: 925px;
    background: url(../../assets/img/market/market104/bg.jpg)no-repeat center;
    position: relative;

    .s6 {
        position: absolute;
        right: 60px;
        bottom: 92px;
        width: 1439px;
        height: 120px;

        .w {
            width: 1439px;
            height: 120px;
            display: flex;
            align-items: center;
            justify-content: center;

            .lis1 {
                color: #340d0b;
                font-size: 57px;
                font-weight: 600;
                margin-right: 80px;
            }

            .daojishi {
                color: #af2918;
                font-size: 60px;
                font-weight: 600;
            }
        }
    }


}
</style>




// WEBPACK FOOTER //
// src/pages/market/market104.vue